<script setup>
import { computed } from 'vue';

const { currentPage, subPage, user, hasSavedItems, windowWidth, isGlobalNavOpen, updatePage, logout, displayAlert } = defineProps({
	currentPage: 'curriculum',
	subPage: '',
	user: Object,
	hasSavedItems: Boolean,
	windowWidth: Number,
	isGlobalNavOpen: Boolean,
	updatePage: Function,
	logout: Function,
	displayAlert: Function,
});
const navBarItems = [
	{
		"label": "Curriculum",
		"iconClasses": "fa-fw fa-solid fa-book",
		"pageName": "curriculum"
	},
	// {
	// 	"label": "Games",
	// 	"iconClasses": "fa-fw fa-solid fa-gamepad",
	// 	"pageName": "games"
	// },
	{
		"label": "Saved",
		"iconClasses": "fa-fw fa-solid fa-bookmark",
		"pageName": "saved"
	},
	/*
	{
		"label": "Noteworthy Quotes",
		"iconClasses": "fa-fw fa-solid fa-quote-right",
		"pageName": "quotes"
	},
	{
		"label": "Notes",
		"iconClasses": "fa-fw fa-regular fa-pen",
		"pageName": "notes"
	},
	{
		"label": "Jobs Board",
		"iconClasses": "fa-fw fa-regular fa-dollar",
		"precedeWithHR": true,
		"pageName": "jobs"
	},
	{
		"label": "Open Roles",
		classes: "subnav",
		"iconClasses": "",
		"pageName": "jobs",
		"subPage": "open-roles"
	},
	{
		"label": "Applied",
		classes: "subnav",
		"iconClasses": "",
		"pageName": "jobs",
		"subPage": "applied"
	},
	{
		"label": "Résumé",
		classes: "subnav",
		"iconClasses": "",
		"pageName": "jobs",
		"subPage": "resume"
	},
	{
		"label": "Interview Tips",
		classes: "subnav",
		"iconClasses": "",
		"pageName": "jobs",
		"subPage": "interview-tips"
	},*/
	{
		"label": "Support",
		"iconClasses": "fa-fw fa-regular fa-glasses",
		"pageName": "support",
	},
	{
		"label": "Contact",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "support",
		"subPage": "contact"
	},
	/*{
		"label": "FAQ",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "support",
		"subPage": "faq"
	},*/
	{
		"label": "Privacy Policy",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "support",
		"subPage": "privacy"
	},
	{
		"label": "Terms of Service",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "support",
		"subPage": "terms"
	},
	{
		"label": "Sign Up / Sign In",
		"iconClasses": "fa-fw fa-solid fa-user",
		// "precedeWithHR": true,
		"pageName": "authenticate",
		"noAuth": true,
	},
	{
		"label": "Account",
		"iconClasses": "fa-fw fa-solid fa-user",
		"precedeWithHR": true,
		"pageName": "account",
		"authReqd": true,
	},
	/*{
		"label": "Profile",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "account",
		"subPage": "profile",
		"authReqd": true,
	},
	{
		"label": "Messages",
		"classes": "subnav",
		"iconClasses": "",
		"pageName": "account",
		"subPage": "messages",
		"authReqd": true,
	},*/
	{
		"label": "Sign Out",
		"iconClasses": "fa-fw fa-solid fa-hexagon-xmark",
		"pageName": "sign-out",
		"authReqd": true,
	},
];

async function logoutUser() {
	try {
		const response = await fetch("/api/auth/signout", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
		});

		const data = await response.json();
		console.log(response);

		if (!response.ok) {
			throw new Error(data.error || "Sign-out failed");
		}

		console.log("Log-out success:", data);
		logout();
	} catch (error) {
		if (error.message == 'The string did not match the expected pattern.' ||
				error.message == `Unexpected token '<', "<!DOCTYPE "... is not valid JSON`) {
			// user likely doesn't have a session. run the logout script and see if it works.
			logout();
		} else {
			displayAlert('Sign-out failed', error.message, 'error', 'Okay');
			console.error("error message:", error);
		}
	}
};

const isTablet = computed(() => {
	return (windowWidth < 1024 && windowWidth >= 768);
});

function handleNavClick(pageName, subPage) {
	if (pageName === 'sign-out') {
		logoutUser();
	} else {
		updatePage(pageName, subPage);
	}
}
</script>

<template>
	<div
		:class="!isGlobalNavOpen ? 'hidden' : ''"
		id="global-nav-drawer"
	>
		<a
			v-for="page in navBarItems.filter(page => page.pageName !== 'saved' || hasSavedItems)"
			@click.stop="handleNavClick(page.pageName, page.subPage)"
			:key="page.subPage ?? page.pageName"
			:class="[
				page.classes,
				(currentPage === page.pageName) && (!page.subPage || subPage === page.subPage) ? 'active' : '',
				(currentPage !== page.pageName) && (page.subPage) ? 'hidden' : '',
				{noAuth: page.noAuth},
				{authReqd: page.authReqd},
				page.precedeWithHR ? 'dividerBefore' : ''
			]"
			:rel="page.subPage ? page.pageName : ''"
			:name="page.subPage ? page.subPage : page.pageName"
		>
			{{page.label}}<span :class="page.iconClasses" aria-hidden="true"></span>
		</a>
	</div>
</template>

<style lang="scss" scoped>
// #global-nav #global-nav-drawer .noAuth {}
#global-nav .authReqd { display: none; }
#global-nav.auth .noAuth { display: none; }
#global-nav.auth .authReqd { display: flex; }
#global-nav-drawer {
	box-shadow: var(--floatingShadow);
	display: flex;
	flex-flow: column;
	gap: 4px;

	background-color: var(--bg3);
	border: 1px solid var(--border);
	border-radius: 20px;
	padding: var(--nav-padding);

	position: fixed;
	inset: auto calc(var(--nav-padding) - 6px) 64px;
	z-index: 9;
}
.tablet + #global-nav-drawer {
	right: auto;
	width: calc(var(--sidebar-width) - 22px - (var(--nav-padding)* 2) - 1px);
}
@media(min-width:1024px){
	#global-nav-drawer,
	.tablet + #global-nav-drawer {
		background-color: var(--bg1);
		border: unset;
		border-radius: unset;
		box-shadow: unset;
		padding: 0 var(--nav-padding) 20px;
		position: static;
	}
}

#global-nav-drawer a {
	border-radius: 4px;
	color: var(--text1);
	cursor: pointer;
	text-decoration: none;
	padding: 4px 0;
	margin-right: 1px;

	display: flex;
	gap: 6px;
	flex-flow: row-reverse;
	justify-content: flex-end;
	align-items: baseline;

	@media(min-width:768px) {
		flex-flow: row;
		justify-content: space-between;
	}

	&.subnav { padding-left: 2em; }
	&:hover, &.active {
		border-color: transparent;
		border-style: solid;
		border-width: 0 4px;
		margin-left: -4px;
		margin-right: -7px;
		padding-right: 4px;
		font-weight: bold;
	}
	&.active { background-color: var(--interactive); }
	&.dividerBefore {
		position: relative;
		margin-top: 18px;
		&::before {
			content: '';
			border-top: 2px solid var(--border);
			display: block;
			position: absolute;
			inset: -12px -4px auto;
		}
	}
}

</style>
